@if (motdMessage) {
  <p>{{ motdMessage.body }}</p>
  <div *nzModalFooter>
    @if (motdMessage.isDismissible) {
      <label nz-checkbox [(ngModel)]="dismissMotdMessage">Vairs nerādīt</label>
    }
    <button nz-button nzType="primary" (click)="close()">OK</button>
  </div>
}
